import {
  BUSINESS_SETTINGS_FAILURE,
  BUSINESS_SETTINGS_REQUEST,
  BUSINESS_SETTINGS_RESET,
  BUSINESS_SETTINGS_SUCCESS,
} from '../actions/business_settings'

export function businessSettings(
  state = {
    isFetching: true,
    settings: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESS_SETTINGS_REQUEST:
      return { ...state, isFetching: true, settings: null, errorMessage: null }
    case BUSINESS_SETTINGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        settings: action.response.results,
        count: action.response.count,
        nextUrl: action.response.next,
        errorMessage: null,
      }
    case BUSINESS_SETTINGS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    case BUSINESS_SETTINGS_RESET:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    default:
      return state
  }
}
